import { FC, MouseEventHandler, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { copyToClipboard } from "../../util/copyToClipboard";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

export const Copyable: FC<{ text: string }> = ({ text }) => {
  const [justCopied, setJustCopied] = useState(false)
  const copy: MouseEventHandler<HTMLSpanElement> = async (event) => {
    event.preventDefault()
    await copyToClipboard(text)
    setJustCopied(true)
    setTimeout(() => setJustCopied(false), 1000)
  }
  return <span className={"text-brand-600 bg-brand-100 cursor-pointer p-1 rounded-sm font-mono text-xs relative"} onClick={copy}>
    <span className={justCopied ? "invisible" : ""}>{text} <FontAwesomeIcon icon={faCopy} /></span>
    {justCopied && <span className={"absolute top-0 left-0 h-full w-full flex items-center justify-center"}>
      <span>Copied{text.length >= 19 ? <>&nbsp;to&nbsp;clipboard</> : <>!</>}</span>
    </span>}
  </span>
}
